// extracted by css-extract-rspack-plugin
export default {"fullScreen":"Loader_fullScreen__+Ds9S","loader":"Loader_loader__wlUE9","authLoader":"Loader_authLoader__7DBgX","circularProgress":"Loader_circularProgress__hP0Pq"};